export const getError = (err: any) => {
    if (err.code) {
        if (err.description !== '') {
            return `${err.code} ${err.items} (${err.description})`;
        }
        return `${err.code} ${err.items}`;
    }
    if (err.message) {
        return err.message;
    }
    return JSON.stringify(err);
};

export enum BrowserStorage {
    LocalStorage = 'localStorage',
    SessionStorage = 'sessionStorage',
}

// Refer the following link for more information.
// https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#testing_for_availability
export const storageAvailable = (type: BrowserStorage) => {
    let storage;

    try {
        storage = window[type];
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return (
            e instanceof DOMException &&
            e.name === 'QuotaExceededError' &&
            // acknowledge QuotaExceededError only if there's something already stored
            storage &&
            storage.length !== 0
        );
    }
};

export const hasCookieAccess = () => {
    if (!storageAvailable(BrowserStorage.LocalStorage) || !storageAvailable(BrowserStorage.SessionStorage)) {
        return false;
    }

    return true;
};
